import { auxiliaryStorage } from "./auxiliaryStorage";
import { useState } from "react";
import { Button } from "@hanjan-shieo/ui";
import { deliverSupportOutbox, loadSupportDraft, queueSupportRequest, saveSupportDraft, supportCategories, type SupportCategory } from "./supportClient";
import { track } from "./platform";

const categoryCopy: Record<SupportCategory, string> = { bug: "기능 문제", accessibility: "접근성", safety: "안전·강요", appeal: "이용 제한 이의신청", game_source: "게임·출처 제보", other: "기타" };

export function SupportPanel() {
  const [initial] = useState(() => {
    try { return { draft: loadSupportDraft(auxiliaryStorage), error: null }; }
    catch { return { draft: { category: "bug" as SupportCategory, body: "" }, error: "이전 문의 초안을 읽지 못했어요. 원본은 보존했어요." }; }
  });
  const [category, setCategory] = useState(initial.draft.category);
  const [body, setBody] = useState(initial.draft.body);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState<{ kind: "saved" | "sent" | "wait"; message: string } | null>(initial.error ? { kind: "wait", message: initial.error } : null);
  async function persist(nextBody = body, nextCategory = category) {
    saveSupportDraft(auxiliaryStorage, { category: nextCategory, body: nextBody });
    try { await auxiliaryStorage.flush(); setStatus({ kind: "saved", message: "초안을 이 기기에 저장했어요. 아직 외부로 전송하지 않았습니다." }); }
    catch { setStatus({ kind: "wait", message: "초안 저장을 확인하지 못했어요. 입력을 유지한 채 다시 시도해 주세요." }); }
  }
  async function submit() {
    setSending(true); setStatus(null);
    try {
      queueSupportRequest(auxiliaryStorage, { category, body });
      await auxiliaryStorage.flush();
      const result = await deliverSupportOutbox(auxiliaryStorage);
      if (result.status === "sent") {
        setBody(""); setStatus({ kind: "sent", message: `접수됐어요. 영수증 ${result.receiptId}${result.cleanupPending ? " · 기기의 초안 정리는 아직 확인하지 못했어요. 다시 전송할 필요는 없어요." : ""}` }); track("support_submitted");
      } else setStatus({ kind: "wait", message: result.reason });
    } catch (reason) { setStatus({ kind: "wait", message: reason instanceof Error ? reason.message : "문의 초안을 확인해 주세요." }); }
    finally { setSending(false); }
  }
  return <div className="support-panel">
    <label>문의 종류<select value={category} onChange={(event) => { const next = event.target.value as SupportCategory; setCategory(next); persist(body, next); }}>{supportCategories.map((value) => <option value={value} key={value}>{categoryCopy[value]}</option>)}</select></label>
    <label>내용<textarea value={body} minLength={10} maxLength={2_000} rows={8} onChange={(event) => { setBody(event.target.value); setStatus(null); saveSupportDraft(auxiliaryStorage, { category, body: event.target.value }); }} placeholder="어떤 화면에서 무엇을 하다가 문제가 생겼나요?" /></label>
    <p className="support-meta">실명·전화번호·음주량·건강정보는 쓰지 마세요. 이의신청은 제한 화면에 표시된 가명 참조와 판단이 잘못됐다고 생각하는 이유만 적습니다. 전송을 누르기 전에는 이 기기의 초안이며, 실패하면 자동 백그라운드 전송하지 않습니다.</p>
    <div className="retention-actions"><Button disabled={body.trim().length < 10 || sending} onClick={submit}>{sending ? "전달 확인 중…" : "문의 전송"}</Button><button className="button button--ghost" onClick={() => persist()}>초안만 저장</button></div>
    {status && <div className={`support-status ${status.kind === "wait" ? "support-status--wait" : ""}`} role={status.kind === "wait" ? "alert" : "status"}><b>{status.kind === "sent" ? "접수 완료" : status.kind === "wait" ? "전달 대기" : "기기 저장"}</b><p>{status.message}</p></div>}
    <p><a className="text-link" href="mailto:support@munops.com">메일 앱으로 직접 문의하기</a></p>
  </div>;
}
